module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-1-photo-5-ab2632797ad78bdfd8d9c4fe1561748d.webp";